import { render, staticRenderFns } from "./checkItem.vue?vue&type=template&id=2c96ba1b&scoped=true&"
import script from "./checkItem.vue?vue&type=script&lang=js&"
export * from "./checkItem.vue?vue&type=script&lang=js&"
import style0 from "./checkItem.vue?vue&type=style&index=0&id=2c96ba1b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c96ba1b",
  null
  
)

export default component.exports